import React from 'react';
import { IoMdClose } from "react-icons/io";


function ClipModalShare({setOpenShareModal}) {
    return (
        <div className="h-40 flex flex-col items-center w-96 inline-block bg-gradient-to-b from-zinc-800 to-custom-black shadow-2xl rounded-xl mx-2">
          <div className="w-10/12 flex flex-col justify-around h-40">
            <div className="flex w-full justify-between items-center">
              <div className="text-white">
                Share
              </div>
              <div
                className="text-white cursor-pointer text-lg"
                onClick={() => {
                  setOpenShareModal(false);
                }}
              >
                <IoMdClose />
              </div>
            </div>
            <div className="w-full h-10 bg-black flex justify-end items-center rounded-lg p-2">
              <div className="bg-blue-500 h-8 w-16 rounded-lg flex justify-center items-center text-white text-sm cursor-pointer">
                Copy
              </div>
            </div>
          </div>
        </div>
    );
}

export default ClipModalShare;
